const defaultStyles = {
  dragHeight: '94px',
};
export const UploadStyles = {
  customProgramUpload: {
    ...defaultStyles,
  },
};
